import { getQueryParam, QueryParams } from '../utils/routing';

const { createReducer } = require('redux-ramda');

export interface QueryStringState {
  sloc: string;
  integrationURL: string;
}

const initialState = {
  sloc: getQueryParam(QueryParams.sloc) || '',
  integrationURL: getQueryParam(QueryParams.IntegrationURL) || '',
};

export const queryString = createReducer(initialState, []);
